<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="dialogAttrs"
        :parent-on="dialogOn"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        @activate="onButtonActivate"
      />
    </template>

    <v-card>
      <v-card-title>Edit Access Control</v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col cols="6">
              <v-select
                v-model="editedItem.access"
                :items="accessTypes"
                label="Access"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="editedItem.owner"
                :items="items"
                item-value="id"
                :item-text="itemText"
                :readonly="!isAdmin"
                label="Owner"
              />
            </v-col>
            <v-col
              v-if="editedItem.access === 'PRIVATE'"
              cols="12"
            >
              <v-select
                v-model="editedItem.read"
                :items="items"
                item-value="id"
                :item-text="itemText"
                :readonly="!isAdmin"
                label="Read"
                multiple
              />
            </v-col>
            <v-col
              v-if="editedItem.access === 'PRIVATE'"
              cols="12"
            >
              <v-select
                v-model="editedItem.write"
                :items="items"
                item-value="id"
                :item-text="itemText"
                :readonly="!isAdmin"
                label="Write"
                multiple
              />
            </v-col>
          </v-row>
          <v-row
            v-if="message"
            class="red"
            dense
          >
            <v-col>
              {{ message }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="onOk"
          aria-label="Update"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogBase from '@/components/dialogs/DialogBase.vue'
import AuthBase from '@/components/auth/AuthBase'
import { AUTH_URL, getErrorMessage } from '@/main'
import { defaultVTooltipProps } from '@/utils/defaultProps'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase, AuthBase],

  props: {
    item: {
      type: [Object, null],
      default: null,
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ['assays', 'protocols', 'reports', 'files'].includes(value),
    },
    apiUrl: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    editedItem: {
      access: 'public',
      owner: null,
      read: [],
      write: [],
    },
    accessTypes: [
      { value: 'PUBLIC', text: 'Public' },
      { value: 'AUTHENTICATED', text: 'Authenticated' },
      { value: 'PRIVATE', text: 'Private' },
    ],
    principals: {},
    defaultVTooltipProps,
  }),

  computed: {
    ...mapGetters(['USERS']),
    items() {
      return [
        ...(this.principals.users ? this.principals.users : []),
        ...(this.principals.groups
          ? this.principals.groups.map((g) => {
              g.type = 'Group'
              return g
            })
          : []),
        ...(this.principals.roles
          ? this.principals.roles.map((r) => {
              r.type = 'Role'
              return r
            })
          : []),
      ]
    },
  },

  watch: {
    dialog(val) {
      this.message = null
      if (val) {
        if (this.item) this.editedItem = Object.assign({}, this.item.acl)

        this.$axios.get(`${AUTH_URL}/principals`).then((response) => {
          this.principals = response.data
        })
      }
    },
  },

  methods: {
    itemText(item) {
      return item.fullName ? `${item.name} (${item.fullName})` : item.type ? `${item.name} (${item.type})` : item.name
    },
    onOk() {
      this.message = null
      this.$axios
        .put(`${this.apiUrl}/${this.type}/${this.item.id}/acl`, this.editedItem)
        .then((response) => {
          this.$emit('aclUpdated', response.data)
          this.dialog = false
        })
        .catch((error) => (this.message = getErrorMessage(error)))
    },
  },
}
</script>
